import styled from 'styled-components';
import { RichTextPartial } from '../../../partials';
import { TypographyStyles, colours, media } from '../../../stylings';

export const TermsAndPolicy = styled(RichTextPartial)`
  > p {
    margin: 0;
  }

  a {
    color: ${colours.BLACK};
  }
`;

export const SuccessMessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media ${media.greaterThan('lg')} {
    flex-direction: column-reverse;
  }
`;

export const SuccessMessageText = styled.p`
  ${TypographyStyles.Body.Small.Regular}

  @media ${media.greaterThan('lg')} {
    margin: 0;
  }
`;

export const SuccessContentContainer = styled.div`
  display: flex;
  gap: 10px;
`;

export const SuccessIcon = styled.div`
  align-items: center;
  display: flex;
  height: 22px;
`;
